import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://c8bbce10cee2e666dce3a4ca9f557abf@o4509071767306240.ingest.de.sentry.io/4509071769534544',

  integrations: [],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

export default Sentry;
